// A select over a list of { value, hint } options: each option shows its hint (what
// an abbreviation like "IM" or "PSD" stands for) beside it, and the chosen one's hint
// becomes the helper text, so the meaning stays visible once the menu shuts.
import { MenuItem, TextField, Typography } from "@mui/material";

export default function HintedSelect({ options, value, onChange, allowBlank = true,
                                       helperText, ...rest }) {
  const chosen = options.find(o => o.value === value);
  return (
    <TextField select fullWidth value={value} onChange={e => onChange(e.target.value)}
               helperText={chosen?.hint || helperText}
               slotProps={{ select: { renderValue: v => v } }} {...rest}>
      {allowBlank && <MenuItem value=""><em>Not set</em></MenuItem>}
      {options.map(o => (
        <MenuItem key={o.value} value={o.value}>
          {o.value}
          {o.hint && (
            <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1 }}>
              {o.hint}
            </Typography>
          )}
        </MenuItem>
      ))}
    </TextField>
  );
}
